import { render, staticRenderFns } from "./Match.vue?vue&type=template&id=caf32d98&scoped=true"
import script from "./Match.vue?vue&type=script&lang=js"
export * from "./Match.vue?vue&type=script&lang=js"
import style0 from "./Match.vue?vue&type=style&index=0&id=caf32d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf32d98",
  null
  
)

export default component.exports